import React from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ArrowRight from '@material-ui/icons/ArrowForward';
import MuiCircularProgress from '@material-ui/core/CircularProgress';
import Button from 'components/MuiComponents/Button';
import RoundedButton from 'components/MuiComponents/RoundedButton';
import { withTranslation } from 'react-i18next';
import PlaceAutocomplete from 'components/PlaceAutocomplete/PlaceAutocomplete';
import * as placesActions from 'redux/modules/searchBar';
import * as plannerActions from 'redux/modules/planner';
import * as customizeActions from 'redux/modules/customizeBooking';
import isEmpty from 'lodash.isempty';
import styled, { ThemeProvider, css } from 'styled-components';
import CountryContext from 'context/CountryContext';
import {
  onErrorHandler,
  ErrorBoundaryFallbackComponent,
  withErrorBoundary
} from 'components/ErrorBoundry/ErrorBoundry';
import { sendGtagEvent } from '../../../utils/gtag';
import theme, { media } from '../../../theme/styled-theme';

const SeparateLine = styled.div`
  display: block;
  background: ${props => props.theme.greyLight60};
  width: 100%;
  height: 1px;
`;

const Form = styled.div`
  display: flex;
  padding: 0.75rem;

  ${media.forPhoneOnly`
    flex-direction: column;
  `}
`;

const FieldContainer = styled.div`
  flex: 1 0 0;
  font-size: 0.75rem;
`;

const ForwardFieldContainer = styled.div`
  font-size: 0.75rem;
`;

const ButtonFieldContainer = styled.div`
  max-width: 142px;
  flex: 1 0 0;
  margin-left: 8px;
  font-size: 0.75rem;

  ${media.forPhoneOnly`
    margin-left: 0;
    max-width: 100%;
  `}
`;

const HideOnMobile = styled.div`
  ${media.forPhoneOnly`
    display: none;
  `}
`;

const Label = styled.p`
  font-size: 12px;
  line-height: 15px;
  margin: 4px 0;

  ${media.forPhoneOnly`
    margin-top: 8px;
  `}
`;

const ForwardIcon = styled.span`
  width: 42px;
  transform: translateY(67%);
  display: flex;
  justify-content: center;
`;

const CircularProgress = styled(MuiCircularProgress)`
  && {
    color: white;
  }
`;

const buttonStyle = {
  root: {
    margin: '0',
    height: '52px',
    minWidth: '138px',
    padding: '0.875rem 1.25rem',
  }
};

@withTranslation(['common'])
@withRouter
@connect(
  state => ({
    loadingOnewayFrom: state.searchBar && state.searchBar.loadingOnewayFrom,
    suggestionOnewayFrom: state.searchBar && state.searchBar.suggestionOnewayFrom,
    onewayFromDestination: state.searchBar && state.searchBar.onewayFromDestination,
    searchedOnewayFrom: state.searchBar && state.searchBar.searchedOnewayFrom,
    placeSearchResultOnewayFrom: state.searchBar && state.searchBar.placeSearchResultOnewayFrom,

    loadingOnewayTo: state.searchBar && state.searchBar.loadingOnewayTo,
    suggestionOnewayTo: state.searchBar && state.searchBar.suggestionOnewayTo,
    onewayToDestination: state.searchBar && state.searchBar.onewayToDestination,
    searchedOnewayTo: state.searchBar && state.searchBar.searchedOnewayTo,
    placeSearchResultOnewayTo: state.searchBar && state.searchBar.placeSearchResultOnewayTo,
  }),
  {
    ...placesActions,
    ...customizeActions,
    ...plannerActions,
  }
)
class Oneway extends React.Component {
  static propTypes = {
    history: PropTypes.objectOf(PropTypes.any).isRequired,
    t: PropTypes.func.isRequired,

    // Planner Reducer
    addPickupPlaceToState: PropTypes.func.isRequired,
    addDropoffPlaceToState: PropTypes.func.isRequired,

    resetPlannerPlan: PropTypes.func.isRequired,
    clearEnquiry: PropTypes.func.isRequired,
    loadingOnewayFrom: PropTypes.bool.isRequired,
    suggestionOnewayFrom: PropTypes.arrayOf(PropTypes.any).isRequired,
    onewayFromDestination: PropTypes.objectOf(PropTypes.any).isRequired,
    searchAutocompleteOnewayFrom: PropTypes.func.isRequired,
    selectOnewayFromPlaceId: PropTypes.func.isRequired,
    clearOnewayFrom: PropTypes.func.isRequired,

    searchKeyWordPlaceOnewayFrom: PropTypes.func.isRequired,
    searchedOnewayFrom: PropTypes.bool.isRequired,
    placeSearchResultOnewayFrom: PropTypes.arrayOf(PropTypes.any).isRequired,
    clearOnewayFromSearchResult: PropTypes.func.isRequired,

    loadingOnewayTo: PropTypes.bool.isRequired,
    suggestionOnewayTo: PropTypes.arrayOf(PropTypes.any).isRequired,
    onewayToDestination: PropTypes.objectOf(PropTypes.any).isRequired,
    searchAutocompleteOnewayTo: PropTypes.func.isRequired,
    selectOnewayToPlaceId: PropTypes.func.isRequired,
    clearOnewayTo: PropTypes.func.isRequired,

    searchKeyWordPlaceOnewayTo: PropTypes.func.isRequired,
    searchedOnewayTo: PropTypes.bool.isRequired,
    placeSearchResultOnewayTo: PropTypes.arrayOf(PropTypes.any).isRequired,
    clearOnewayToSearchResult: PropTypes.func.isRequired,
  };

  static defaultProps = {
  };

  static contextType = CountryContext;

  constructor(props) {
    super(props);

    this.handleCheckPrice = this.handleCheckPrice.bind(this);

    this.state = {
      buttonLoading: false,
    };
  }

  handleCheckPrice(e) {
    e.preventDefault();
    sendGtagEvent('Check Price from landing', 'Goal', 'One Way');
    const {
      addPickupPlaceToState,
      addDropoffPlaceToState,
      onewayToDestination,
      onewayFromDestination,
      clearEnquiry,
      resetPlannerPlan,
      history
    } = this.props;
    const { code } = this.context;

    this.setState(
      { buttonLoading: true },
      () => {
        this.timer = setTimeout(() => {
          this.setState({ buttonLoading: false });
        }, 2000);
      },
    );

    clearEnquiry();
    resetPlannerPlan();
    addPickupPlaceToState({ place: onewayFromDestination, day: 0 });
    addDropoffPlaceToState({ place: onewayToDestination, day: 0 });

    if (__SERVER__ && window.swUpdate) {
      window.location = `/itinerary/customize/pricing/?searchBar=true&country=${code}`;
      return;
    }

    return history.push({
      pathname: '/itinerary/customize/pricing',
      search: `?searchBar=true&country=${code}`,
      state: {
        oneway: true
      }
    });
  }

  render() {
    const {
      loadingOnewayFrom,
      suggestionOnewayFrom,
      onewayFromDestination,
      searchAutocompleteOnewayFrom,
      searchKeyWordPlaceOnewayFrom,
      searchedOnewayFrom,
      placeSearchResultOnewayFrom,
      clearOnewayFromSearchResult,
      selectOnewayFromPlaceId,
      clearOnewayFrom,

      loadingOnewayTo,
      suggestionOnewayTo,
      onewayToDestination,
      searchAutocompleteOnewayTo,
      searchKeyWordPlaceOnewayTo,
      searchedOnewayTo,
      placeSearchResultOnewayTo,
      clearOnewayToSearchResult,
      selectOnewayToPlaceId,
      clearOnewayTo,
      t
    } = this.props;

    const { buttonLoading } = this.state;

    return (
      <ThemeProvider theme={theme}>
        <div>
          <Form>
            <FieldContainer>
              <Label>{t('SEARCHBAR.TAB.ONEWAY.FROM')}</Label>
              <PlaceAutocomplete
                name="from"
                loadingSuggestion={loadingOnewayFrom}
                suggestion={suggestionOnewayFrom}
                currentSelection={onewayFromDestination}
                searchAutocompletePlace={searchAutocompleteOnewayFrom}
                selectPlaceId={selectOnewayFromPlaceId}
                clearSelection={clearOnewayFrom}
                placeHolder={t('SEARCHBAR.TAB.ONEWAY.FROM_PLACEHOLDER')}
                searchKeyWordPlace={searchKeyWordPlaceOnewayFrom}
                searched={searchedOnewayFrom}
                searchResult={placeSearchResultOnewayFrom}
                clearSearchResult={clearOnewayFromSearchResult}
              />
            </FieldContainer>

            <ForwardFieldContainer>
              <HideOnMobile>
                <Label>&nbsp;</Label>
                <ForwardIcon><ArrowRight /></ForwardIcon>
              </HideOnMobile>
            </ForwardFieldContainer>

            <FieldContainer>
              <Label>{t('SEARCHBAR.TAB.ONEWAY.TO')}</Label>
              <PlaceAutocomplete
                name="to"
                loadingSuggestion={loadingOnewayTo}
                suggestion={suggestionOnewayTo}
                currentSelection={onewayToDestination}
                searchAutocompletePlace={searchAutocompleteOnewayTo}
                selectPlaceId={selectOnewayToPlaceId}
                clearSelection={clearOnewayTo}
                placeHolder={t('SEARCHBAR.TAB.ONEWAY.TO_PLACEHOLDER')}
                searchKeyWordPlace={searchKeyWordPlaceOnewayTo}
                searched={searchedOnewayTo}
                searchResult={placeSearchResultOnewayTo}
                clearSearchResult={clearOnewayToSearchResult}
              />
            </FieldContainer>
            <ButtonFieldContainer>
              <Label>&nbsp;</Label>
              <div>
                <RoundedButton
                  data-cy="cy-oneway-checkprice"
                  variant="contained"
                  color="primary"
                  key={t('CHECK_PRICE')}
                  label={t('CHECK_PRICE')}
                  onClick={this.handleCheckPrice}
                  disabled={isEmpty(onewayToDestination) || isEmpty(onewayFromDestination)}
                  overwritestyles={buttonStyle}
                  fullWidth
                >
                  { buttonLoading ? <CircularProgress size={24} /> : t('CHECK_PRICE') }
                </RoundedButton>
              </div>
            </ButtonFieldContainer>
          </Form>
          <SeparateLine />
          <Form>
            <Label>{t('SEARCHBAR.TAB.ONEWAY.EXPLANATION')}</Label>
          </Form>
        </div>
      </ThemeProvider>
    );
  }
}

export default withErrorBoundary(
  Oneway,
  ErrorBoundaryFallbackComponent,
  onErrorHandler,
);
